module.exports = __webpack_public_path__ + "static/media/adv-banner-img1.403f4319.png";